import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 border',
  {
    variants: {
      variant: {
        default: 'bg-primary-50 text-primary-700 border-primary-100 hover:bg-primary-100',
        success: 'bg-success-light text-success-dark border-success-light/50 hover:bg-success-light/80',
        warning: 'bg-warning-light text-warning-dark border-warning-light/50 hover:bg-warning-light/80',
        error: 'bg-error-light text-error-dark border-error-light/50 hover:bg-error-light/80',
        info: 'bg-info-light text-info-dark border-info-light/50 hover:bg-info-light/80',
        outline: 'border-border text-text-secondary hover:bg-neutral-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
